/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import Slider from "react-slick";
import {useIsMobile} from "../../hoc/hooks";

interface IProps {

}

export const CardsContainer: FunctionComponent<IProps> = ({children}) => {

    const isMobile = useIsMobile("1200px");
    const length = children?.toString().split(",").length;

    const responsiveness = [
        {
            breakpoint: 1200,
            settings: {
                slidesToScroll: 1,
                slidesToShow: length > 2 ? 3 : 2,
            }
        },
        {
            breakpoint: 980,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 760,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: length > 2 ? 3 : 2,
        slidesToScroll: 1,
        responsive: responsiveness
    };

    return <div className="card-container-slick-wrapper">
        {isMobile ? <Slider {...settings} className="card-container-slider">{children}</Slider> : children}
    </div>

};
